import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Save, Building2 } from 'lucide-react';
import { toast } from 'sonner';
import { useSettings } from '../../contexts/SettingsContext';
import ImageUpload from './ImageUpload';

const BrandingManager = () => {
  const { settings, updateSettings } = useSettings();
  const [form, setForm] = useState({
    mosque_name: settings.mosque_name || '',
    tagline: settings.tagline || '',
    location_city: settings.location_city || '',
    location_address: settings.location_address || '',
    logo_url: settings.logo_url || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateSettings(form);
      toast.success('Branding masjid berhasil disimpan!');
    } catch (error) {
      toast.error('Gagal menyimpan branding');
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="bg-white rounded-2xl border border-stone-200 p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-emerald-50 flex items-center justify-center">
            <Building2 className="w-6 h-6 text-emerald-700" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-bold text-primary-dark">Identitas Masjid</h3>
            <p className="text-sm font-body text-text-secondary">Nama, lokasi, dan logo masjid</p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-body font-medium text-text-primary mb-2">Nama Masjid *</label>
            <input
              type="text"
              data-testid="branding-name-input"
              value={form.mosque_name}
              onChange={(e) => setForm({ ...form, mosque_name: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body"
              placeholder="Masjid Raya"
            />
          </div>

          <div>
            <label className="block text-sm font-body font-medium text-text-primary mb-2">Tagline</label>
            <input
              type="text"
              data-testid="branding-tagline-input"
              value={form.tagline}
              onChange={(e) => setForm({ ...form, tagline: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body"
              placeholder="Memakmurkan Masjid, Memberdayakan Umat"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-body font-medium text-text-primary mb-2">Kota</label>
              <input
                type="text"
                data-testid="branding-city-input"
                value={form.location_city}
                onChange={(e) => setForm({ ...form, location_city: e.target.value })}
                className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body"
                placeholder="Jakarta"
              />
            </div>
            <div>
              <label className="block text-sm font-body font-medium text-text-primary mb-2">Alamat</label>
              <input
                type="text"
                data-testid="branding-address-input"
                value={form.location_address}
                onChange={(e) => setForm({ ...form, location_address: e.target.value })}
                className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body"
                placeholder="Jl. Masjid Raya No. 123"
              />
            </div>
          </div>

          <div>
            <ImageUpload
              value={form.logo_url}
              onChange={(url) => setForm({ ...form, logo_url: url })}
              label="Logo Masjid"
            />
          </div>
        </div>

        <button
          data-testid="branding-save-btn"
          onClick={handleSave}
          disabled={saving}
          className="mt-6 flex items-center gap-2 px-6 py-3 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full font-body font-medium transition-colors disabled:opacity-50"
        >
          <Save className="w-5 h-5" />
          {saving ? 'Menyimpan...' : 'Simpan Branding'}
        </button>
      </div>
    </motion.div>
  );
};

export default BrandingManager;
